import { render, staticRenderFns } from "./ApproverSourcePicker.vue?vue&type=template&id=8dac461e"
import script from "./ApproverSourcePicker.vue?vue&type=script&lang=js"
export * from "./ApproverSourcePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports